// import './base/';
// import './utilities/is-touch';
// import './utilities/responsive-images';
// import './cart/cart';
// import './cart/cart-utils';
// import './sliders/product-slider';
// import './product/ajax-actions';
// import './product/quantity';
// import './polyfills/object-fit';
import './podcast/handle-podcast-select';
import './blog/load-more';
import './form/form-custom-select';

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed
